module.exports = __webpack_public_path__ + "img/安阳市.e925c49b.png";